import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useShellBilling } from './useShellBilling';

const BILLING_PATH = '/settings/billing';

/**
 * The shell's credit banner (spec 10 §6, T140-1-5, AC-10-058): for members who
 * run AI jobs, a warning while less than 10 % of the granted credits are left
 * and when none are. Silent while loading, on errors and for every other
 * level: the billing page shows those states.
 */
export function CreditBanner() {
  const { t } = useTranslation();
  const location = useLocation();
  const { canUseAi, billing } = useShellBilling();
  const level = billing.data?.level;
  if (!canUseAi || (level !== 'low' && level !== 'exhausted')) return null;
  return (
    <div className="ui-blocked-banner ui-blocked-banner--shell" role="status">
      <AlertTriangle className="ui-blocked-banner__icon" aria-hidden="true" size={20} />
      <p className="ui-blocked-banner__text">
        {level === 'exhausted' ? t('billing.banner.exhausted') : t('billing.banner.low', { credits: t('billing.balance.credits', { count: billing.data?.available ?? 0 }) })}
      </p>
      {location.pathname === BILLING_PATH ? null : (
        <div className="ui-blocked-banner__actions">
          <Link className="ui-btn ui-btn--secondary" to={BILLING_PATH}>
            {t('billing.banner.action')}
          </Link>
        </div>
      )}
    </div>
  );
}
